module.exports = __webpack_public_path__ + "static/media/s.d00cc2e3.png";